import React from 'react';
import { ListItemProps } from './types';
import { styleListItem } from './style';
import clsx from 'clsx';
import ButtonBase from '../ButtonBase';

const ListItem = (props: ListItemProps) => {
  const { className, children, selected, icon, as, innerClassName, ...rest } =
    props;

  const tag = as || (rest.onClick || rest.href ? 'button' : 'div');
  const cls = styleListItem(props);
  return (
    <li className={clsx(cls.wrapper, className)}>
      <ButtonBase className={clsx(cls.main, className)} as={tag} {...rest}>
        {icon && <span className={clsx(cls.icon)}>{icon}</span>}
        <span className={clsx(cls.inner, innerClassName)}>{children}</span>
      </ButtonBase>
    </li>
  );
};

export default ListItem;
